// The React pages a page area can hold, by the data-entry name the server
// prints on their root (services\ssr\ServerRenderedRoot). Each loads its code on
// demand and returns { element(props, area), activate?(area) }: element builds
// what mounts on the root; activate wires anything outside it and returns a
// cleanup for when the page leaves. ssr/entries.jsx lists the same names.
const pageEntries = {
 bugProposals: async () => {
  const { default: BugProposalsPage } = await import(/* webpackChunkName: "BugProposalsPage" */ 'react/bugProposals/BugProposalsPage');
  return { element: props => <BugProposalsPage {...props} /> };
 },
	modImpersonation: async () => {
		const { default: ImpersonationPage } = await import(/* webpackChunkName: "ModImpersonation" */ 'react/modConsole/ImpersonationPage');
		return { element: (props) => <ImpersonationPage {...props} /> };
	},
	countries: async () => {
		const { default: CountriesPage } = await import(/* webpackChunkName: "CountriesPage" */ 'react/countries/CountriesPage');
		return { element: (props) => <CountriesPage {...props} /> };
	},
	home: async () => {
		const { default: BroadcastHub } = await import(/* webpackChunkName: "BroadcastHub" */ 'react/home/BroadcastHub');
		return { element: (props) => <BroadcastHub {...props} /> };
	},
	rankings: async () => {
		const { default: RankingsApp } = await import(/* webpackChunkName: "RankingsApp" */ 'react/rankings/RankingsApp');
		return { element: (props) => <RankingsApp initialProps={props} /> };
	},
	subscribe: async () => {
		const { default: SubscribePage } = await import(/* webpackChunkName: "SubscribePage" */ 'react/subscribe/SubscribePage');
		return { element: (props) => <SubscribePage {...props} /> };
	},
	subscriptions: async () => {
		const { default: SubscriptionsPage } = await import(/* webpackChunkName: "SubscriptionsPage" */ 'react/subscriptions/SubscriptionsPage');
		return { element: (props) => <SubscriptionsPage {...props} /> };
	},
	permissions: async () => {
		const { default: PermissionsPage } = await import(/* webpackChunkName: "PermissionsPage" */ 'react/permissions/PermissionsPage');
		return { element: (props) => <PermissionsPage {...props} /> };
	},
	permissionRoster: async () => {
		const { default: PermissionRosterPage } = await import(/* webpackChunkName: "PermissionRosterPage" */ 'react/permissions/PermissionRosterPage');
		return { element: (props) => <PermissionRosterPage {...props} /> };
	},
	locationSettings: async () => {
		const { default: LocationSettingsPage } = await import(/* webpackChunkName: "LocationSettingsPage" */ 'react/location/LocationSettingsPage');
		return { element: (props) => <LocationSettingsPage {...props} /> };
	},
	distanceMap: async () => {
		const { default: DistanceMapPage } = await import(/* webpackChunkName: "DistanceMapPage" */ 'react/distanceMap/DistanceMapPage');
		return { element: (props) => <DistanceMapPage {...props} /> };
	},
	bugs: async () => {
		const { default: BugsPage } = await import(/* webpackChunkName: "BugsPage" */ 'react/bugs/BugsPage');
		return { element: (props) => <BugsPage {...props} /> };
	},
	flairManager: async () => {
		const { default: FlairManagerPage } = await import(/* webpackChunkName: "FlairManagerPage" */ 'react/flairManager/FlairManagerPage');
		return { element: (props) => <FlairManagerPage {...props} /> };
	},
	modAccounts: async () => {
		const { default: ModAccountsPage } = await import(/* webpackChunkName: "ModAccountsPage" */ 'react/modAccounts/ModAccountsPage');
		return { element: (props) => <ModAccountsPage {...props} /> };
	},
	modDisputes: async () => {
		const { default: ModDisputesPage } = await import(/* webpackChunkName: "ModDisputesPage" */ 'react/modDisputes/ModDisputesPage');
		return { element: (props) => <ModDisputesPage {...props} /> };
	},
	modFlaggedMatches: async () => {
		const { default: ModFlaggedMatchesPage } = await import(/* webpackChunkName: "ModFlaggedMatchesPage" */ 'react/modFlaggedMatches/ModFlaggedMatchesPage');
		return { element: (props) => <ModFlaggedMatchesPage {...props} /> };
	},
	modInbox: async () => {
		const { default: ModInboxPage } = await import(/* webpackChunkName: "ModInboxPage" */ 'react/modInbox/ModInboxPage');
		return { element: (props) => <ModInboxPage {...props} /> };
	},
	modQueryStats: async () => {
		const { default: ModQueryStatsPage } = await import(/* webpackChunkName: "ModQueryStatsPage" */ 'react/modQueryStats/ModQueryStatsPage');
		return { element: (props) => <ModQueryStatsPage {...props} /> };
	},
	modShell: async () => {
		const { default: ModShell } = await import(/* webpackChunkName: "ModShell" */ 'react/modConsole/ModShell');
		return { element: (props) => <ModShell {...props} /> };
	},
	modHome: async () => {
		const { default: ModHome } = await import(/* webpackChunkName: "ModHome" */ 'react/modConsole/ModHome');
		return { element: (props) => <ModHome {...props} /> };
	},
	roomManager: () => import(/* webpackChunkName: "RoomManagerPage" */ 'react/roomManager/roomManagerEntry'),
	ladderEditor: () => import(/* webpackChunkName: "LadderEditorPage" */ 'react/ladderEditor/ladderEditorEntry'),
	ladderEditorLanding: async () => {
		const { default: LadderEditorLandingPage } = await import(/* webpackChunkName: "LadderEditorLandingPage" */ 'react/ladderEditor/landing/LadderEditorLandingPage');
		return { element: (props) => <LadderEditorLandingPage {...props} /> };
	},
	matchPage: async () => {
		const { default: MatchPage } = await import(/* webpackChunkName: "MatchPage" */ 'react/matchPage/MatchPage');
		return { element: (props, area, { restored } = {}) => <MatchPage initialProps={props} restored={restored} /> };
	},
	slippiLive: async () => {
		const { default: SlippiLivePage } = await import(/* webpackChunkName: "SlippiLivePage" */ 'slippi/SlippiLivePage');
		return { element: (props) => <SlippiLivePage {...props} /> };
	},
	brawlOnlineReplays: async () => {
		const { default: BrawlOnlineReplaysPage } = await import(/* webpackChunkName: "BrawlOnlineReplaysPage" */ 'slippi/brawlOnline/BrawlOnlineReplaysPage');
		return { element: (props) => <BrawlOnlineReplaysPage {...props} /> };
	},
	matchResultLab: async () => {
		const { default: MatchResultLab } = await import(/* webpackChunkName: "MatchResultLab" */ 'react/matchResult/MatchResultLab');
		return { element: () => <MatchResultLab /> };
	},
	profile: () => import(/* webpackChunkName: "ProfilePage" */ 'react/profile/page/profileEntry'),
	rankedPlayerStats: () => import(/* webpackChunkName: "RankedPlayerStats" */ 'react/stats/rankedPlayerStatsEntry'),
	netplay: () => import(/* webpackChunkName: "NetplayPage" */ 'react/netplay/netplayEntry'),
	accountSettings: () => import(/* webpackChunkName: "AccountSettingsPage" */ 'react/settings/AccountSettings/accountSettingsEntry'),
};

export default pageEntries;
